import createPollApi from '@rhg/libs/api/create-poll-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { queryKeys, useQuery } from '@rhg/libs/react-query';
import { useActiveCircle } from '../use-active-circle';

export const pollSubmissionQueryOptions = {
    queryKey: function ({
        recipientId,
        pollId,
    }: {
        pollId: string;
        recipientId: number;
    }) {
        return [queryKeys.pollSubmission, recipientId, pollId];
    },
    queryFn: async function ({
        getAccessTokenSilently,
        pollId,
        recipientId,
        circleAuthorizationToken,
    }: {
        getAccessTokenSilently: () => Promise<string>;
        pollId: string;
        recipientId: number;
        circleAuthorizationToken: string;
    }) {
        const pollApi = createPollApi(getAccessTokenSilently);

        const response =
            await pollApi.getV1PollsRecipientsRecipientIdPollPollId({
                pollId,
                recipientId,
                circleAuthorizationToken,
            });

        return response.data;
    },
    queryOptions: function ({
        pollId,
        recipientId,
        isAuthenticated,
    }: {
        pollId: string;
        recipientId: number;
        isAuthenticated: boolean;
    }) {
        return {
            enabled: !!(isAuthenticated && pollId && recipientId),
        };
    },
};

export function usePollSubmissions({ pollId = '' }: { pollId?: string }) {
    const { isAuthenticated, getAccessTokenSilently } = useAuth();
    const { queryKey, queryFn, queryOptions } = pollSubmissionQueryOptions;
    const { activeCircle, activeCircleId } = useActiveCircle();

    const { data, ...otherProps } = useQuery({
        queryKey: queryKey({ pollId, recipientId: activeCircleId! }),
        queryFn: async () =>
            queryFn({
                getAccessTokenSilently,
                pollId,
                recipientId: activeCircleId!,
                circleAuthorizationToken: activeCircle!.authorizationJWT!,
            }),
        ...queryOptions({
            pollId,
            recipientId: activeCircleId!,
            isAuthenticated,
        }),
    });
    return {
        pollSubmissions: data,
        ...otherProps,
    };
}
